<template>
  <a-drawer width="50%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-row :gutter="12">
        <a-col :span="10">
          <a-form-model-item label="姓名" prop="realName" >
            <a-input v-model="form.realName" placeholder="请输入" disabled/>
          </a-form-model-item>
        </a-col>
        <a-col :span="10">
          <a-form-model-item label="手机号" prop="mobile">
            <a-input v-model="form.mobile" placeholder="请输入" disabled />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-tabs v-model="activeKey">
        <a-tab-pane key="1" tab="基本信息">
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="身份证号" prop="idCard" >
                <a-input v-model="form.idCard" placeholder="请输入" disabled />
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="出生年月" prop="birthday">
                <a-date-picker
                  v-model="form.birthday"
                  valueFormat="YYYY-MM-DD"
                  format="YYYY-MM-DD"
                  disabled
                  allow-clear/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="性别" prop="sex" >
                <a-select v-model="form.sex" placeholder="请选择" disabled>
                  <a-select-option :value="1">男</a-select-option>
                  <a-select-option :value="2">女</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="微信号" prop="wxCode">
                <a-input v-model="form.wxCode" placeholder="请输入" disabled/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="银行卡" prop="bankNo" >
                <a-input v-model="form.bankNo" placeholder="请输入" disabled/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="身份证国徽面" prop="idCardFront" >
                <img style="height:200px;max-width:300px" v-image-preview :src="form.idCardFront"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="身份证人像面" prop="idCardReverse">
                <img style="height:200px;max-width:300px" v-image-preview :src="form.idCardReverse"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="户籍" prop="address" >
                <a-input v-model="form.address" placeholder="请输入" disabled/>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-tab-pane>
        <a-tab-pane key="2" tab="来源信息">
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="首次登录注册时间" prop="createTime" >
                <a-input v-model="form.createTime" placeholder="请输入" disabled />
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="邀请所属" prop="inviteUserNickname" >
                <a-input v-model="form.inviteUserNickname" placeholder="请输入" disabled />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="来源渠道" prop="sourceChannelName" >
                <a-input v-model="form.sourceChannelName" placeholder="请输入" disabled />
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="来源类型" prop="sourceType">
                <a-select v-model="form.sourceType" placeholder="请选择" disabled >
                  <a-select-option :value="1">平台分享</a-select-option>
                  <a-select-option :value="2">招聘专员分享</a-select-option>
                  <a-select-option :value="3">推荐官分享</a-select-option>
                  <a-select-option :value="4">推荐官专员分享</a-select-option>
                  <a-select-option :value="5">驻场客服分享</a-select-option>
                  <a-select-option :value="6">其他</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="推荐官专员" prop="topReferralsNickname">
                <a-select v-model="form.topReferralsUserId" placeholder="请选择" optionFilterProp="children" disabled>
                  <a-select-option v-for="(topReferralsUser,index) in topReferralsUserList" :key="index" :value="topReferralsUser.id">
                    {{ topReferralsUser.nickname }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-tab-pane>
        <a-tab-pane key="3" tab="银行卡信息" force-render>
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="银行卡号" prop="bankNo" >
                <a-input v-model="form.bankNo" placeholder="请输入" disabled />
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="开户行" prop="bankSubName" >
                <a-input v-model="form.bankSubName" placeholder="请输入" disabled />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="开户地" prop="cateName" >
                <a-input v-model="form.cateName" placeholder="请输入" disabled />
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="真实姓名" prop="realName">
                <a-input v-model="form.realName" placeholder="请输入" disabled />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="银行预留手机号" prop="bankMobile" >
                <a-input v-model="form.bankMobile" placeholder="请输入" disabled />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-tab-pane>
        <a-tab-pane key="4" tab="合同信息">
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="合同名称" prop="avatar" >
                <a-input v-model="form.realName + '劳动合同'" placeholder="请输入" disabled />
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="合同开始时间" prop="avatar" >
                <a-date-picker
                  v-model="contractForm.startTime"
                  valueFormat="YYYY-MM-DD"
                  format="YYYY-MM-DD"
                  disabled
                  allow-clear/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item label="合同结束时间" prop="avatar" >
                <a-date-picker
                  v-model="contractForm.endTime"
                  valueFormat="YYYY-MM-DD"
                  format="YYYY-MM-DD"
                  disable
                  allow-clear/>
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="合同文件">
                <div v-if="form.fileUrl && form.fileUrl.trim() !== ''">
                  <a :href="form.fileUrl" target="_blank">
                    <a-icon type="download" /> 合同下载
                  </a>
                  <a-button type="link" @click="removeContractFile">
                    <a-icon type="delete" /> 删除
                  </a-button>
                </div>
                <div v-else>
                  <a-upload
                    :show-upload-list="false"
                    :before-upload="beforeContractUpload"
                    :customRequest="handleContractUpload"
                    accept=".pdf,.doc,.docx,.xls,.xlsx"
                  >
                    <a-button>
                      <a-icon type="upload" /> 上传合同
                    </a-button>
                  </a-upload>
                  <div class="upload-tip">支持 PDF、Word、Excel 格式，文件大小不超过 10MB</div>
                </div>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-tab-pane>
        <a-tab-pane key="5" tab="会员客户">
          <a-table
            :size="tableSize"
            rowKey="id"
            :columns="columns"
            :data-source="list"
            :pagination="false"
            :bordered="tableBordered"
            :scroll="{ x: 500}"
          ></a-table>
        </a-tab-pane>
        <a-tab-pane key="6" tab="跟进记录">
          <UserFollow :followList = "this.followList"/>
        </a-tab-pane>
        <a-tab-pane key="7" tab="银行卡变更记录">
          <BankHistory :userId="form.userId"/>
        </a-tab-pane>
        <a-tab-pane key="8" tab="佣金记录">
          <BrokerageRecordForm :userId="form.userId"/>
        </a-tab-pane>
<!--        <a-tab-pane key="5" tab="佣金信息">-->
<!--          <a-row :gutter="12">-->
<!--            <a-col :span="10">-->
<!--              <a-form-model-item label="头像" prop="avatar" >-->
<!--              </a-form-model-item>-->
<!--            </a-col>-->
<!--            <a-col :span="10">-->
<!--              <a-form-model-item label="头像" prop="avatar" >-->
<!--              </a-form-model-item>-->
<!--            </a-col>-->
<!--          </a-row>-->
<!--        </a-tab-pane>-->

      </a-tabs>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { tableMixin } from '@/store/table-mixin'
import { getReferrals, addReferrals, updateReferrals, contractList } from '@/api/user/referrals'
import UserForm from "@/views/user/referrals/modules/UserForm.vue";
import {queryUserByType, pageReferralsUser, queryFollowListById} from "@/api/biz/user";
import UserFollow from "@/views/user/referrals/modules/UserFollow.vue";
import BankHistory from "@/views/user/referrals/modules/BankHistory.vue";
import BrokerageRecordForm from "@/views/user/referrals/modules/BrokerageRecordForm.vue";
import UploadFileToOSS from '@/utils/upload-file-to-oss.js'

export default {
  name: 'CreateForm',
  props: {
  },
  mixins: [tableMixin],
  components: {
    UserForm,
    UserFollow,
    BankHistory,
    BrokerageRecordForm
  },
  data () {
    return {
      activeKey: '1',
      submitLoading: false,
      formTitle: '',
      referralsUserList: [],
      topReferralsUserList: [],
      // 表单参数
      form: {
        id: null,
        userId: null,
        realName: null,
        mobile: null,
        idCard: null,
        birthday: null,
        sex: null,
        wxCode: null,
        topUserNickname: null,
        idCardFront: null,
        idCardReverse: null,
        fileUrl: '',
        status: 0,
        cateName: null,
        createTime: null,
        remark: null,
        inviteUserNickname: null,
        sourceChannelName: null,
        sourceType: null,
        referralsUserId: null,
        topReferralsUserId: null,
        bankNo: null,
        bankSubName: null,
        bankMobile: null,
      },
      contractForm: {
        name: null,
        startTime: null,
        endTime: null
      },
      columns:[
        {
          title: '姓名',
          dataIndex: 'realName',
          align: 'center',
        },
        {
          title: '手机号码',
          dataIndex: 'mobile',
          align: 'center',
        },
        {
          title: '身份证号',
          dataIndex: 'idCard',
          align: 'center',
        },
      ],
      list: [],
      followList: [],
      total: null,
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        cateName: [
          { required: true, message: '分类名称不能为空', trigger: 'blur' }
        ]
      },
      contractUploadLoading: false
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
    open(val) {
      if (val && this.formType === 2) {
        // 抽屉打开且是修改模式时，初始化佣金记录
        this.$nextTick(() => {
          if (this.$refs.brokerageRecordForm) {
            this.$refs.brokerageRecordForm.show(this.form)
          }
        })
      }
    }
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        idCardFront: null,
        idCardReverse: null,
        fileUrl: '',
        status: 0,
        cateName: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.listUserByType(3)
      this.formType = 2
      const id = row ? row.id : ids
      getReferrals({"id":id}).then(response => {
        this.form = response.data
        this.form.bankNo = row.bankNo
        this.open = true
        this.formTitle = '修改'
      })
      contractList({userId: row.userId}).then(res => {
        this.contractForm.startTime = res.data[0].createTime.split(' ')[0]
        // 处理结束时间
        const startDate = new Date(this.contractForm.startTime + 'T00:00:00Z'); // 解析为UTC时间
        startDate.setUTCFullYear(startDate.getUTCFullYear() + 5); // 加5年
        this.contractForm.endTime = startDate.toISOString().split('T')[0]; // 格式化为YYYY-MM-DD
      })
      pageReferralsUser({referralsUserId: row.userId}).then(response => {
        this.list = response.data.records
        this.total = response.data.total
      })
      queryFollowListById({userId: row.userId}).then(res => {
        this.followList = res.data
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateReferrals(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addReferrals(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    listUserByType(type) {
      const param = { type: type }
      queryUserByType(param).then(response => {
        if (type === 1) {
          this.topUserList = response.data
        }
        if (type === 2) {
          this.referralsUserList = response.data
        }
        if (type === 3) {
          this.topReferralsUserList = response.data
        }
      })
    },
    // 合同文件上传前验证
    beforeContractUpload(file) {
      const isValidType = /\.(pdf|doc|docx|xls|xlsx)$/i.test(file.name)
      if (!isValidType) {
        this.$message.error('只支持 PDF、Word、Excel 格式的文件!')
        return false
      }
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('文件大小不能超过 10MB!')
        return false
      }
      return true
    },
    // 处理合同文件上传
    handleContractUpload(info) {
      this.contractUploadLoading = true
      new UploadFileToOSS([info.file], {
        finally: (res) => {
          console.log('合同文件上传成功', res)
          this.contractUploadLoading = false
          if (res && res.length > 0) {
            const fileUrl = res[0].url || res[0].path
            this.form.fileUrl = fileUrl
            // 上传完成后直接调用更新接口
            this.updateContractFile(fileUrl)
          }
        },
        error: (error) => {
          console.error('合同文件上传失败', error)
          this.contractUploadLoading = false
          this.$message.error('文件上传失败，请重试')
        }
      })
    },
        // 更新合同文件URL
    updateContractFile(fileUrl) {
      if (!this.form.id) {
        this.$message.warning('请先保存基本信息，再上传合同文件')
        return
      }
      
      const updateData = {
        id: this.form.id,
        fileUrl: fileUrl
      }
      
      updateReferrals(updateData).then(response => {
        this.$message.success('合同文件上传成功')
        this.form.fileUrl = fileUrl
      }).catch(error => {
        console.error('更新合同文件失败', error)
        this.$message.error('更新合同文件失败，请重试')
        // 回滚文件URL
        this.form.fileUrl = ''
      })
    },
        // 删除合同文件
    removeContractFile() {
      this.$confirm({
        title: '确认删除',
        content: '确定要删除这个合同文件吗？',
        onOk: () => {
          if (!this.form.id) {
            this.form.fileUrl = ''
            return
          }
          
          const updateData = {
            id: this.form.id,
            fileUrl: ''
          }
          
          updateReferrals(updateData).then(response => {
            this.$message.success('合同文件删除成功')
            this.form.fileUrl = ''
          }).catch(error => {
            console.error('删除合同文件失败', error)
            this.$message.error('删除合同文件失败，请重试')
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.upload-tip {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
  line-height: 1.4;
}

.ant-form-item {
  .ant-btn-link {
    padding: 0;
    height: auto;
    margin-left: 8px;
  }
}
</style>
